import { render } from "./AddPlatFormVideoCate.vue?vue&type=template&id=ffe5a84c&scoped=true"
import script from "./AddPlatFormVideoCate.vue?vue&type=script&lang=js"
export * from "./AddPlatFormVideoCate.vue?vue&type=script&lang=js"

import "./AddPlatFormVideoCate.vue?vue&type=style&index=0&id=ffe5a84c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffe5a84c"]])

export default __exports__